import type { ReactNode } from 'react';
import { useIsMobileBreakpoint } from '@/hooks/useIsBreakpoint';
import { type BoxProps, Flex } from '@/ui';
import { useEntryModalContext } from '../../contexts';

type Props = {
  children: ReactNode;
  onSubmit?: () => void;
};

export const EntryModalForm = ({ children, onSubmit }: Props) => {
  const isMobileBreakpoint = useIsMobileBreakpoint();
  const { activeSidebarPanel } = useEntryModalContext();

  // Styles for the pseudo element that draws the sidebar's box shadow
  // when the sidebar is open
  const shadowProps: BoxProps['_after'] = isMobileBreakpoint
    ? undefined
    : {
        content: `""`,
        opacity: activeSidebarPanel ? 1 : 0,
        transition: 'all 0.2s ease',
        boxShadow: '5px 0px 8px 0px rgba(0,0,0,0.1)',
        height: '100%',
        width: activeSidebarPanel ? '10px' : 0,
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
      };

  return (
    <Flex
      _after={shadowProps}
      as="form"
      bg="white"
      borderLeftRadius="md"
      borderRightRadius={activeSidebarPanel ? 'none' : 'md'}
      direction="column"
      flex="1"
      noValidate
      overflowY="auto"
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit?.();
      }}
    >
      {children}
    </Flex>
  );
};
